import { AiFillCloseCircle } from "react-icons/ai";
import styled from "styled-components";

// ⓵ ⓶ ⓷ ⓸ ⓹ ⓺ ⓻ ⓼ ⓽ ⓾

export const Question = styled.div`
  text-align: center;

  font-size: 34px;

  border-top: 0.5px solid white;
  border-bottom: 0.5px solid white;
  padding: 10px 0;
`;

export const Container = styled.div`
  width: 100%;
  height: 100%;

  padding: 10px 5px;

  color: white;

  max-width: 600px;

  margin: auto;
`;

export const NumberText = styled.div``;

export const Wrapper = styled.div<{ $correct?: boolean; $incorrect?: boolean }>`
  position: relative;
  cursor: pointer;

  border: ${({ $correct }) => $correct && "3px solid lightgreen"};
  border: ${({ $incorrect }) => $incorrect && "3px solid red"};

  border-radius: 10px;

  padding: 10px;
`;

export const CloseIcon = styled(AiFillCloseCircle)`
  font-size: 50px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  color: #d3d3d3c0;
`;

export const Desc = styled.div`
  font-size: 20px;

  & strong {
    font-size: 30px;
  }
`;
